<template>
  <v-app>
    <v-row
      v-if="!errorpage && !datepage && !template"
      justify="center"
      align="center"
    >
      <v-progress-circular indeterminate color="purple"></v-progress-circular>
      <span class="ml-2">Заявка загружается...</span>
    </v-row>
    <div
      v-if="!errorpage && template"
      :style="
        'height: 100%; overflow-x: hidden; background-color: #' +
          template.interface.colorscheme.background
      "
    >
      <v-sheet
        :color="'#' + template.interface.colorscheme.project"
        :height="270"
      ></v-sheet>
      <h1
        class="apply-title"
        :style="'color: #' + template.interface.colorscheme.font"
      >
        {{ template.interface.interface_application_name }}
      </h1>
      <v-row class="justify-center">
        <v-card class="apply-card mb-6" :max-width="640">
          <v-sheet
            :color="'#' + template.interface.colorscheme.hover"
            :height="5"
          >
          </v-sheet>
          <p class="ma-4">{{template.description}}</p>
          <v-card-text>
            <v-form v-if="formShow" ref="form" v-model="valid">
              <v-col
                :key="i"
                v-for="(item, i) in template.visitors_additional_fields"
              >
                <h2>
                  {{
                    item.field_required
                      ? item.field_text + "*"
                      : item.field_text + ""
                  }}
                </h2>
                <v-text-field
                  :rules="
                    item.field_required
                      ? [requiredRule, symbolsRule]
                      : [symbolsRule]
                  "
                  :placeholder="item.field_default"
                  v-model="item.value"
                >
                </v-text-field>
              </v-col>
              <v-row>
              <v-btn
                :disabled="!valid"
                color="success"
                class="ml-4"
                @click="send"
              >
                Отправить
              </v-btn>
              
             <v-tooltip bottom>
      <template v-slot:activator="{ on }">
              <span class="ml-4 mt-2"
              
                  @click="copyvalue(template.external_id)"
                  style="cursor:pointer"
              v-on="on"
                >ID заявки:
                {{ template.external_id }}</span
              ></template>
              Нажмите, чтобы скопировать. 
              Идентификатор может понадобиться Вам, чтобы запросить QR-код в ВКонтакте для прохода на территорию университета. 
             </v-tooltip>
              </v-row>
             
<v-col>                              <span style="font-size: 11px" >Нажимая на кнопку отправить, вы соглашаетесь с обработкой персональных данных</span>
</v-col>
            </v-form>
            <h2 v-else>Форма успешно отправлена!</h2>
          </v-card-text>
        </v-card>
      </v-row>
    </div>
    <div v-if="errorpage">
      <v-col style=" margin-top: 20%; ">
        <v-icon
          :size="100"
          style="margin-left: 50%; transform: translateX(-50%);"
          color="warning"
          >mdi-alert-circle-outline</v-icon
        >
        <br />
        <h2 align="center">
          Ай-яй! Вы поймали 404 ошибку.
        </h2>
      </v-col>
    </div>
    <div v-if="datepage">
      <v-col style=" margin-top: 20%; ">
        <v-icon
          :size="100"
          style="margin-left: 50%; transform: translateX(-50%);"
          >mdi-timer-sand-empty</v-icon
        >
        <br />
        <h2 align="center">
          Упс, время заявки еще не пришло
        </h2>
      </v-col>
    </div>
    <v-snackbar  :color="snackbar.color" v-model="snackbar.status">
      {{ snackbar.text }}
      <v-btn text @click="snackbar.status = false">
        Закрыть
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    template: null,
    valid: false,
    formShow: true,
    loading: false,
    loaded: false,
    errorpage: false,
    datepage: false,
    requiredRule: v => !!v || "Обязательно для заполнения",
    symbolsRule: value => {
      const pattern = /[^A-Za-z0-9А-Яа-я!@._ -,()]/;
      return !pattern.test(value) || "Вы используете запрещенные символы";
    },
    snackbar: {
      status: false,
      text: "",
      color: ""
    }
  }),
  methods: {
    copyvalue(value) {
      const copyToClipboard = value => {
        const el = document.createElement("textarea"); // Create a <textarea> element
        el.value = value; // Set its value to the string that you want copied
        el.setAttribute("readonly", ""); // Make it readonly to be tamper-proof
        el.style.position = "absolute";
        el.style.left = "-9999px"; // Move outside the screen to make it invisible
        document.body.appendChild(el); // Append the <textarea> element to the HTML document
        const selected =
          document.getSelection().rangeCount > 0 // Check if there is any content selected previously
            ? document.getSelection().getRangeAt(0) // Store selection if found
            : false; // Mark as false to know no selection existed before
        el.select(); // Select the <textarea> content
        document.execCommand("copy"); // Copy - only works as a result of a user action (e.g. click events)
        document.body.removeChild(el); // Remove the <textarea> element
        if (selected) {
          // If a selection existed before copying
          document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
          document.getSelection().addRange(selected); // Restore the original selection
          this.snackbar.status = true;
            this.snackbar.text = 'Идентификатор скопирован в буфер обмена';
            this.snackbar.color = "success";
        }
      };
      copyToClipboard(value)
    },
    send() {
      let visitors = this.template.visitors_additional_fields.map(field => {
        return { settings_id: field.settings_id, value: field.value };
      });
      let data = {
        external_id: this.$route.path.split("/")[1],
        visitors
      };
      let requestOptions = {
        body: JSON.stringify(data),
        method: "POST"
      };
      fetch("http://10.5.2.80:80/rd/", requestOptions).then(res => {
        res.json().then(data => {
          if (res.ok) {
            this.snackbar.status = true;
            this.snackbar.text = "Заявка успешно отправлена";
            this.snackbar.color = "success";
            this.formShow = false;
          } else {
            this.snackbar.status = true;
            this.snackbar.text = data.message;
            this.snackbar.color = "error";
          }
        });
      });
    }
  },

  created() {
    this.loading = true;
    fetch(
      "http://10.5.2.80:80/gai/?external_id=" + this.$route.path.split("/")[1]
    )
      .then(res => {
        if (res.status == 200) {
          res.json().then(data => {
            this.template = data;
            document.title = data.interface.interface_title;
          });
        } else if (res.status == 401) {
          document.title = "Заявка еще недоступна";
          this.datepage = true;
        } else {
          this.snackbar.status = true;
          this.snackbar.text = data.message;
          this.snackbar.color = "error";
          this.errorpage = true;
        }

        this.loading = false;
      })
      .catch(err => {
        this.errorpage = true;
      });
  }
};
</script>

<style lang="scss">
.apply-card {
  margin-top: -100px !important;
  width: 100% !important;
}

.apply-title {
  position: absolute;
  top: 60px;
  left: 50px;
}

@media (max-width: 767px) {
  .apply-card {
    margin-left: 5%;
    margin-right: 5%;
  }
  .apply-title {
    top: 20px;
    left: 20px;
    font-size: 26px;
    line-height: 1.5em;
  }
  .logo {
    width: 100%;
    opacity: 0.2;
  }
}
</style>
